import uploadFilesTemplate from '../../templates/global/upload_files_template.ejs';
import questionTypeFilesTemplate from '../../templates/question_types/files_template.ejs';

const ImportUploadFilesTemplateFactory = () => ({
    uploadFilesTemplate,
    questionTypeFilesTemplate
});
export default ImportUploadFilesTemplateFactory;
